export const command_definitions = Object.freeze({
    prepopulate_signup_form: "prepopulate_signup_form",
    set_badge_value: "3_day_free_trial",
    set_crm_default_welcome_team_index: "default_crm",
    set_industry_default_welcome_page_index: "default_industry",
});
